module.exports = __webpack_public_path__ + "img/volvo_exit_active.9c5edade.svg";